import { Dimension } from '@pubstack/common/src/analytics/dimension'
import { AnalyticsQueryDashboard, CoreWebVitalsMetricsBySite } from '@pubstack/common/src/analytics/query'
import { DeviceType } from '@pubstack/common/src/device-type'
import { useAtomValue } from 'jotai'
import { DateTime } from 'luxon'
import { FunctionComponent, useState } from 'react'
import { useAnalyticsQueryTanstack } from '~/api/analytics/analytics-query.api'
import { useBreadcrumbs } from '~/hooks/useBreadcrumbs'
import { useScopeCurrency } from '~/hooks/useScopeCurrency.hooks'
import { AnalyticsPage } from '~/modules/analytics/AnalyticsPage'
import { contextState, currentScopeState } from '~/state'
import { PureCoreWebVitalsOverviewTable } from './PureCoreWebVitalsOverviewTable'

const DIMENSIONS: Dimension[] = ['tagId']
const DASHBOARD: AnalyticsQueryDashboard = { name: 'core-web-vitals', filterType: 'auctions' }

export const CoreWebVitalsOverviewPage: FunctionComponent = () => {
  const scope = useAtomValue(currentScopeState)
  const context = useAtomValue(contextState)
  const [device, setDevice] = useState<DeviceType>('desktop')
  const analyticsQuery = useAnalyticsQueryTanstack<CoreWebVitalsMetricsBySite>('cwv.metrics.by.site', DIMENSIONS, context, { device })
  const currencySymbol = useScopeCurrency()

  const breadcrumbs = useBreadcrumbs()
  const timeRange = {
    from: DateTime.local().minus({ days: 29 }).endOf('day'),
    to: DateTime.local().minus({ days: 1 }).startOf('day'),
    tz: scope.timezone,
  }
  return (
    <AnalyticsPage
      onRefreshClick={() => analyticsQuery.refetch()}
      filterDimensions={DIMENSIONS}
      dashboard={DASHBOARD}
      title={breadcrumbs}
      disableDatepicker={true}
      overrideSelectedTimeRange={timeRange}
      timePresets={[]}
    >
      <PureCoreWebVitalsOverviewTable
        onDeviceSelected={setDevice}
        onRefreshClick={() => analyticsQuery.refetch()}
        currencySymbol={currencySymbol}
        rawData={analyticsQuery.data ?? { name: [] }}
        error={analyticsQuery.isError}
        empty={!analyticsQuery.isLoading && !analyticsQuery.data?.name.length}
        isLoading={analyticsQuery.isFetching}
        onSortChange={() => {}}
      />
    </AnalyticsPage>
  )
}
